import { useNavigate } from "react-router-dom";
import Typography from "@mui/material/Typography";
import type { BatchJob } from "../../../../../lib/corpusApi";
import type { UsePaginatedDataResult } from "../../../../../hooks/useAsyncPaginatedData";
import {
  DataSequence,
  type DataSequenceColumn,
} from "../../../../../components/primitives/data-display/DataSequence";
import { LoadingState } from "../../../../../components/primitives/feedback/LoadingState";
import { BatchJobStatusBadge } from "../../../../../components/domain/data-display/BatchJobStatusBadge";
import { ROUTES } from "../../../../../route_paths";

const COLUMNS: DataSequenceColumn<BatchJob>[] = [
  { key: "name", header: "Run", cardRole: "primary", cell: (job) => job.name },
  {
    key: "papers",
    header: "New papers",
    cell: (job) => job.itemCount.toLocaleString(),
  },
  {
    key: "status",
    header: "Status",
    cell: (job) => <BatchJobStatusBadge status={job.status} />,
  },
  {
    key: "started",
    header: "Started",
    cell: (job) => (
      <Typography variant="caption" color="text.secondary">
        {new Date(job.startedAt ?? job.createdAt).toLocaleString()}
      </Typography>
    ),
  },
];

interface FeedRunsProps {
  runs: UsePaginatedDataResult<BatchJob>;
}

/** A feed's runs, newest first. A run is a batch job, so selecting one opens its own page. */
export function FeedRuns({ runs }: FeedRunsProps) {
  const navigate = useNavigate();

  return runs.loading ? (
    <LoadingState />
  ) : (
    <DataSequence
      columns={COLUMNS}
      rows={runs.items}
      getRowId={(job) => job.id}
      emptyMessage="This feed has not run yet."
      pagination={runs.pagination}
      onRowClick={(job) => navigate(ROUTES.internal.batchJobs.detail.path({ id: job.id }))}
    />
  );
}
